import { StoreProps } from '@/app/models/store'
import { ProjectsService } from '@/app/services/ProjectsService'
import { layoutActions } from '@Techedge/digitalportal-shared'
import {
    getActivityTaskPhoto,
    getProjectDetails,
    resetActivityTaskPhoto,
} from './activity-execution'

export const NewActivityApprovalActions = {
    SET_SELECTED_STORES: 'SET_SELECTED_STORES',
    SET_APPROVAL_STORE_LIST: 'SET_APPROVAL_STORE_LIST',
    SET_CHART_DATA: 'SET_CHART_DATA',
    GET_APPROVAL_PROJECT_REQUEST: 'GET_APPROVAL_PROJECT_REQUEST',
    GET_APPROVAL_PROJECT_SUCCESS: 'GET_APPROVAL_PROJECT_SUCCESS',
    GET_APPROVAL_PROJECT_ERROR: 'GET_APPROVAL_PROJECT_FAILURE',
}

export const setSelectedStores = (stores: StoreProps[]) => {
    return { type: NewActivityApprovalActions.SET_SELECTED_STORES, stores }
}
export const setApprovalStoreList = (value: StoreProps[]) => {
    return { type: NewActivityApprovalActions.SET_APPROVAL_STORE_LIST, value }
}
export const setChartData = (chartData) => {
    return { type: NewActivityApprovalActions.SET_CHART_DATA, chartData }
}
export const getApprovalProjectRequest = () => {
    return { type: NewActivityApprovalActions.GET_APPROVAL_PROJECT_REQUEST }
}

export const getApprovalProjectError = (error?: any) => {
    return {
        type: NewActivityApprovalActions.GET_APPROVAL_PROJECT_ERROR,
        toastList: [
            {
                text: error,
            },
        ],
    }
}

export const getApprovalDetailsSuccess = (text: string) => {
    return {
        type: NewActivityApprovalActions.GET_APPROVAL_PROJECT_SUCCESS,
        toastList: [
            {
                text,
            },
        ],
    }
}

export const approveStore = ({
    projectId,
    storeId,
    successMessage,
    reloadPhotoList,
}: {
    projectId: string
    storeId: string
    successMessage: string
    reloadPhotoList: boolean
}) => {
    return (dispatch: any) => {
        dispatch(getApprovalProjectRequest())
        dispatch(layoutActions.setModals({ props: { loading: true } }))
        ProjectsService.ApproveStore(projectId, storeId)
            .then((res: any) => {
                if (res && res.data && !res.data.output) {
                    dispatch(getApprovalDetailsSuccess(successMessage))
                    dispatch(getProjectDetails(projectId, [storeId], true))
                    if (reloadPhotoList) dispatch(resetActivityTaskPhoto())
                    dispatch(getActivityTaskPhoto(projectId, storeId, { page: 1, pageSize: 10 }))
                } else {
                    dispatch(getApprovalProjectError(res.data.output.payload.message))
                    dispatch(layoutActions.setModals({ props: { loading: false } }))
                }
            })
            .catch((error: any) => {
                dispatch(getApprovalProjectError(error.response?.data?.message || error.message))
                dispatch(layoutActions.setModals({ props: { loading: false } }))
            })
    }
}
export const closeProject = (
    projectId: string,
    storeIds: string[],
    successMessage: string,
    storeIdList
) => {
    return (dispatch: any) => {
        dispatch(getApprovalProjectRequest())
        dispatch(layoutActions.setModals({ props: { loading: true } }))
        ProjectsService.CloseProject(projectId, storeIds)
            .then((res: any) => {
                if (res && res.data && !res.data.output) {
                    dispatch(getApprovalDetailsSuccess(successMessage))
                    dispatch(getProjectDetails(projectId, storeIdList))
                } else {
                    dispatch(getApprovalProjectError(res.data.output.payload.message))
                    dispatch(layoutActions.setModals({ props: { loading: false } }))
                }
            })
            .catch((error: any) => {
                dispatch(getApprovalProjectError(error.response?.data?.message || error.message))
                dispatch(layoutActions.setModals({ props: { loading: false } }))
            })
    }
}
export const redoStore = (
    projectId: string,
    storeIds: string[],
    questionsReasons: string,
    tasksReasons: string,
    surveysReasons: string,
    successMessage: string,
    successCallback?: () => void,
    storeIdList?
) => {
    return (dispatch: any) => {
        dispatch(getApprovalProjectRequest())
        dispatch(layoutActions.setModals({ props: { loading: true } }))
        ProjectsService.RedoStore(
            projectId,
            storeIds,
            questionsReasons,
            tasksReasons,
            surveysReasons
        )
            .then((res: any) => {
                if (res && res.data && !res.data.output) {
                    dispatch(getApprovalDetailsSuccess(successMessage))
                    successCallback()
                    dispatch(getProjectDetails(projectId, storeIdList))
                } else {
                    dispatch(getApprovalProjectError(res.data.output.payload.message))
                    dispatch(layoutActions.setModals({ props: { loading: false } }))
                }
            })
            .catch((error: any) => {
                dispatch(getApprovalProjectError(error.response?.data?.message || error.message))
                dispatch(layoutActions.setModals({ props: { loading: false } }))
            })
    }
}
